import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import domtoimage from 'dom-to-image'
import { CONST_API_NODEJS_URL } from '../../../../constants'
import ProjectsService from '../../../../services/projects.service'
import { pxToInch } from '../../../../pages/reportsPpt/commonFunctions'
import { useGlobalStore } from '../../../../store'
// import { nodeJsonFunc } from './exportToPptWithNode/common'
import { getObjectAsArray, getLogData, timeStampToDate, decodeAndStrip, fakeDelay, showCustomDevTool } from '../../../../util'
import { ExportInfoToolTip } from './styles'

const ExportToPptWithNode = ({ isDownloading, setDownloading, checkIsDownloadingFunc }) => {
  const [checkStatus, setCheckStatus] = useState('stop')
  const [pptFileName, setPptFileName] = useState(null)
  const [pptToolTipValues, setPptToolTipValues] = useState(null)
  const [pptData, setPptData] = useState(null)
  
  const {
      pptSubLhs,
      setPPTSubLhs,
      pptSubLhsAppendices,
      setPPTSubLhsAppendices,
      pptSubLhsProgression,
      setPPTSubLhsProgression,
      setPPTModalActive,
      setPPTModalActiveAndClicked,
      setPptIdsType,
      exportToPptObject,
      projectIdValue,
  } = useGlobalStore()

  const { IsFreezed } = projectIdValue
  
  const isCustomImage__ethnographyPieBarChartIds = [
    // AMAZON
    '9d0c623b-b2de-11ed-817c-0a1ea4c5532f',
    '5e95d366-6bf1-11ee-817c-0a1ea4c5532f',
    '63357b94-b2da-11ee-9f55-0a1ea4c5532f',
    '70a2369b-fafb-11ee-8482-128e718ba88f',
    'ee0f401e-424d-11ef-8482-128e718ba88f',
    '2e0c6172-882b-11ef-8482-128e718ba88f',
    '00365fa2-53c5-4639-b6df-cd19d5961109',
    // MAHINDRA
    '2a887346-722b-11ef-8482-128e718ba88f',
  ]

  const singleImageArray = [
    'BrandHealthSetup', 'CategoryExplorationSetup', 'ProductRatingOptimizationSetup', 'BrandMagnetScore', 'BrandMagnetScoreAndProgression', 'ImpactDestinations', 'ImpactDestinationsAndProgression',
    'BrandCategoryOverview', 'BrandCategoryOverviewAndProgression', 'CampaignSegmentsEngagementOverview', 'CampaignSegmentsEngagementProgression',
    'BrandImageryMappingTable', 'BrandAttributeMapElement', 'BrandAttributeMapAndProgression',
    'Triangulation', 'TriangulationComparisonViewOnly', 'TriangulationMapElement', 'TriangulationMapAndProgression', 'TriangulationMapElementLog10', 'TriangulationMapAndProgressionLog10',
    'BuzzMetrics', 'CampaignAndIssuesAssessmentSetup',
  ]
  const multipleImageObject = [
    {type:'CustomImage', selector:'.customImageRow'},
    {type:'Snapshot', selector:'.snapshotRow'},
    {type:'BrandImageryMappingAndProgressionGraph', selector:'.brandImageryRowImg'},
    {type:'BrandImageryMappingGraph', selector:'.brandImageryRowImg'},
    {type:'InsightsMiningFrameworkWithoutSentiments', selector:'.segmentRow'},
    {type:'CampaignTriggers', selector:'.pptSectionWrap'},
    {type:'MultiBrandNPS', selector:'.barWrapper'},
    {type:'DriversProgression', selector:'.segmentRows'},
    {type:'SearchDriversProgression', selector:'.segmentRows'},
    {type:'DriversProgressionWithoutSentiments', selector:'.segmentRows'},
    {type:'CategoryPersona', selector:'.segmentChild'},
    {type:'DriversProgression3Level', selector:'.segmentRows'},
    {type:'SearchDriversProgression3Level', selector:'.segmentRows'},
    {type:'DriversProgressionWithoutSentiments3Level', selector:'.segmentRows'},
  ]
  const multipleImageArray = multipleImageObject.map(d => d.type)
  const rteArray = [ 'Recommendation', 'RecommendationAndProgression', 'CustomTable', 'BusinessObjective' ]

  const localStorageKey = 'downloadPptFileDetails'

  async function downloadFile(url, fileName) {
    if ((localStorage.getItem('blobUrl') === null || localStorage.getItem('blobUrl') === undefined) && localStorage.getItem(localStorageKey)) {
      const response = await fetch(url);
      if (!response.ok) throw new Error("Download failed");
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      localStorage.setItem('blobUrl', blobUrl);
      
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      if (localStorage.getItem(localStorageKey)) {
        link.click();
      }

      URL.revokeObjectURL(blobUrl);
    }
  }

  const getPptStatus = (fileName) => {
    setPptToolTipValues([0, 50])

    fetch(`${CONST_API_NODEJS_URL}/status`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ fileName: fileName }),
    })
      .then((response) => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(async (data) => {
        if (data?.fileExists && localStorage.getItem(localStorageKey)) {
          await fakeDelay(5000);
          const fullDownloadUrl = CONST_API_NODEJS_URL + data.downloadUrl + ".pptx";
          setPptToolTipValues([10, 10])

          await downloadFile(fullDownloadUrl, data.fileName);

          // Log download finish time & duration
          const downloadCompleteTime = new Date();
          const startTimestamp = localStorage.getItem('reportApiStartTime');
          let durationStr = '';
          if (startTimestamp) {
            const durationSec = ((downloadCompleteTime.getTime() - parseInt(startTimestamp, 10)) / 1000).toFixed(2);
            durationStr = ` (Total Duration: ${durationSec}s)`;
            localStorage.removeItem('reportApiStartTime');
          }
          if(showCustomDevTool('dev')){console.log(`[ExporttoPPT] Report successfully downloaded at: ${downloadCompleteTime.toLocaleDateString()} ${downloadCompleteTime.toLocaleTimeString()}${durationStr}`);}

          localStorage.removeItem(localStorageKey);
          
          await fakeDelay(1000)
          window.location.reload();
        } else {
          if (data.status === 'processing') {
              const pendingCount = data.processLog ? data.processLog.pending.length : '...';
              const totalElements = data.processLog ? (data.processLog.completed.length + data.processLog.pending.length + data.processLog.errors.length) : '...';
              setPptToolTipValues([totalElements - pendingCount, totalElements])
          }
          setTimeout(() => { getPptStatusFunc() }, 3000)
        }
      })
      .catch(async (error) => {
        console.error('Error:', error);
        setPptToolTipValues([10, 10])
        localStorage.removeItem(localStorageKey);
        await fakeDelay(1000)
        window.location.reload();
      });
  }

  function normalizeHtml(str) {
    if (!str) return '<div></div>';
    str = str.replace(/&nbsp;/g, '');
    str = str.replace(/\n/g, '');
    str = str.replace(/<([a-z][a-z0-9]*)\b[^>]*>\s*<\/\1>/gi, '');
    str = str.replaceAll('<div>', '').replaceAll('</div>', '');
    return `<div>${str}</div>`;
  }

  const getData = async (exportToPptObject, pptData) => {
    if (!pptData || !Array.isArray(pptData) || pptData.length === 0) {
      console.warn("getData: pptData is missing or empty.");
      setDownloading(false);
      return;
    }

    const data = pptData;
    const studyId = data[0]?.StudyId;
    if (!studyId) {
      console.error("getData: StudyId is missing from the first element.");
      setDownloading(false);
      return;
    }

    const studyLogs = getLogData('GetStudies', 'GetStudies', {}, { StudyId: studyId });
    const projectIdValueTemp = studyLogs?.[0];
    if (!projectIdValueTemp?.ProjectId) {
      console.error("getData: ProjectId could not be resolved.");
      setDownloading(false);
      return;
    }

    try {
      const resp = await ProjectsService.projectsDetailApi({ projectId: projectIdValueTemp.ProjectId }, true);
      const obj = getObjectAsArray(resp).find(f => f.StudyId === studyId);
      
      if (!obj) {
        throw new Error(`Project details not found for studyId: ${studyId}`);
      }

      const headerLogData = obj.ProjectId
        ? getLogData('GetProjects', 'GetProjects', {}, { ProjectId: obj.ProjectId })?.[0] || {}
        : {};

      const headerObj = {
        studyId: obj.StudyId,
        breadCrumb: headerLogData.ProjectType || '',
        title: `${headerLogData.BrandName || headerLogData.CategoryName || 'Unknown'} ${headerLogData.ProjectType || ''}`,
        subTitle: `${headerLogData.MarketName || ''} | ${obj.Period || ''}`,
        lastUpdated: timeStampToDate(headerLogData.ModifiedDate),
        studyTitle: `${headerLogData.BrandName || headerLogData.CategoryName || 'Unknown'}`,
        studySubTitle: `${headerLogData.ProjectType || ''}, ${headerLogData.MarketName || ''}`,
      }

      await fakeDelay(1200)

      const preparedItems = data.map(d => {
        if (!d) return null;
        const insightsData = d?.Insights?.replaceAll('\n', '') || null;
        const cleanedInsights = insightsData ? normalizeHtml(insightsData) : null;
        const elementType = d.InsightsElementType || 'UnknownType';
        const elementId = d.InsightsElementId ? d.InsightsElementId.replaceAll('-', '_') : Math.random().toString(36).substring(7);
        const id = `${elementType}__${elementId}`;
        return { ...d, cleanedInsights, id };
      }).filter(Boolean);

      await Promise.all(
        preparedItems.map(async (item) => {
          let insightsPPT = null;
          if (item.cleanedInsights) {
            try {
              const newDiv = document.createElement("div");
              newDiv.id = "reportHeadingRteInsights__" + item.id;
              newDiv.innerHTML = item.cleanedInsights;
              document.body.appendChild(newDiv);

              const id_headingInsight = document.getElementById("reportHeadingRteInsights__" + item.id);
              insightsPPT = id_headingInsight?.childNodes
                ? await nodeJsonFunc(id_headingInsight.childNodes, 'jsonObject_headingInsights')
                : null;

              newDiv.remove();
            } catch (domErr) {
              console.warn(`Failed to parse insight node for ${item.id}:`, domErr);
            }
          }
          item.InsightsPPT = insightsPPT;
        })
      );

      if(showCustomDevTool('dev')){console.log(`[ExporttoPPT] Total items queued for processing: ${preparedItems.length}`);}
      
      let successCount = 0;
      let errorCount = 0;

      const finalDataPromises = preparedItems.map(async (d, index) => {
        try {
          if (!d) {
            errorCount++;
            if(showCustomDevTool('dev')){console.warn(`[ExporttoPPT] Item index ${index} skipped: Item data is null/undefined.`);}
            return null;
          }

          let skipThisObj = false;
          let base64 = null;
          let pptDataVal = null;

          if (singleImageArray.includes(d.InsightsElementType)) {
            base64 = await convertSingleImageToBase64(d);
          } else if (['CustomImage'].includes(d.InsightsElementType) && !isCustomImage__ethnographyPieBarChartIds.includes(d.InsightsElementId)) {
            base64 = await convertSingleImageToBase64(d);
          } else if (['BrandImageryMappingAndProgressionGraph', 'BrandImageryMappingGraph'].includes(d.InsightsElementType)) {
            const selectorObj = multipleImageObject.find(f => f.type === d.InsightsElementType);
            const imgType = ['BrandImageryMappingAndProgressionGraph', 'BrandImageryMappingGraph'].includes(d.InsightsElementType) ? 'png' : 'jpeg';
            base64 = selectorObj ? await convertMultiImageToBase64WithDims({ d: d, ...selectorObj, type: imgType }) : [];
          } else if (multipleImageArray.includes(d.InsightsElementType)) {
            const selectorObj = multipleImageObject.find(f => f.type === d.InsightsElementType);
            base64 = selectorObj ? await convertMultiImageToBase64WithDims({ d: d, ...selectorObj, type: 'jpeg' }) : [];
          } else if (rteArray.includes(d.InsightsElementType)) {
            const val = exportToPptObject?.[d.id];
            if (val === undefined) {
              skipThisObj = true;
            }
            pptDataVal = val;
          }

          if (skipThisObj) {
            errorCount++;
            if(showCustomDevTool('dev')){console.warn(`[ExporttoPPT] Item index ${index} (${d.id}) skipped: Missing required exportToPptObject value.`);}
            return null;
          }

          successCount++;
          if(showCustomDevTool('dev')){console.log(`[ExporttoPPT] Success [${successCount}/${preparedItems.length}]: Processed element ${d.id}`);}

          return {
            StudyId: d.StudyId,
            TabId: d.TabId,
            InsightsElementId: d.InsightsElementId,
            EntityId: d.EntityId,
            InsightsElementType: d.InsightsElementType,
            Title: d.Title || '',
            ParentTitle: d.ParentTitle || '',
            Heading: d.Heading ? decodeAndStrip(d.Heading) : '',
            Insights: d.cleanedInsights,
            InsightsPPT: d.InsightsPPT,
            Observations: d.Observations,
            InsightsElementOrder: d.InsightsElementOrder,
            id: d.id,
            base64: base64,
            pptData: pptDataVal,
            isAppendices: pptSubLhsAppendices?.length > 0,
            isProgression: pptSubLhsProgression?.length > 0,
            isFreezed: IsFreezed
          };
        } catch (itemErr) {
          errorCount++;
          if(showCustomDevTool('dev')){console.error(`[ExporttoPPT] Error [Failure #${errorCount}] processing item index ${index} [${d?.id || 'unknown'}]:`, itemErr);}
          return null;
        }
      });

      const resolvedFinalData = await Promise.all(finalDataPromises);
      const finalData = resolvedFinalData.filter(Boolean);

      if(showCustomDevTool('dev')){console.log(`[ExporttoPPT] Queue complete. Total Promises: ${preparedItems.length} | Successful: ${successCount} | Failed/Skipped: ${errorCount} | Final Resolved Payload: ${finalData.length}`);}

      if (finalData.length === 0 || (successCount + errorCount !== preparedItems.length)) {
        throw new Error("No valid export data could be resolved from payload items or queue completion mismatch.");
      }

      const getSafeLogoBase64 = async (elementId, type) => {
        try {
          return await convertSingleImageToBase64(null, elementId, type);
        } catch {
          return '';
        }
      };

      const logoDetails = {
        big: {
          logoImg: document.getElementById('downloadLogoBig')?.getAttribute('src') || '',
          logoImgBase64: await getSafeLogoBase64('downloadLogoBig', 'png'),
          logoH: parseInt(document.getElementById('downloadLogoBig')?.height || 0),
          logoW: parseInt(document.getElementById('downloadLogoBig')?.width || 0)
        },
        small: {
          logoImg: document.getElementById('downloadLogoSmall')?.getAttribute('src') || '',
          logoImgBase64: await getSafeLogoBase64('downloadLogoSmall', 'png'),
          logoH: parseInt(document.getElementById('downloadLogoSmall')?.height || 0),
          logoW: parseInt(document.getElementById('downloadLogoSmall')?.width || 0)
        }
      }

      const clientLogoDetails = {
        big: {
          path: logoDetails.big.logoImgBase64,
          w: pxToInch(logoDetails.big.logoW),
          h: pxToInch(logoDetails.big.logoH),
        },
        small: {
          path: logoDetails.small.logoImgBase64,
          w: pxToInch(logoDetails.small.logoW),
          h: pxToInch(logoDetails.small.logoH),
        }
      };

      const props = {
        title: headerObj.title,
        subTitle: headerObj.subTitle,
        lastUpdated: headerObj.lastUpdated,
        logoDetails: clientLogoDetails,
        studyDetails: headerObj,
        isFreezed: IsFreezed
      };

      const safeTitle = props.studyDetails?.studyTitle?.replaceAll(' ', '') || 'Study';
      const safeBreadCrumb = props.studyDetails?.breadCrumb?.replaceAll(' ', '') || 'Report';
      const safeSubTitle = props.studyDetails?.subTitle?.split('|')[1]?.replaceAll(' ', '') || 'Data';
      const fileName = `Study_${safeTitle}_${safeBreadCrumb}_${safeSubTitle}__${Date.now()}`;
      
      const ppptObj = { fileName, method: '', props, payload: finalData };

      const postWithRetry = async (url, options, retries = 3, delayMs = 2000) => {
        let attempt = 0;
        let lastError = null;

        while (attempt < retries) {
          try {
            const res = await fetch(url, options);
            if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
            return res;
          } catch (err) {
            lastError = err;
            attempt += 1;
            if (attempt < retries) {
              await fakeDelay(delayMs);
            }
          }
        }
        throw lastError;
      };

      // Log start time of Reports API call & store timestamp
      const startTime = new Date();
      if(showCustomDevTool('dev')){console.log(`[ExporttoPPT] Reports API call started at: ${startTime.toLocaleDateString()} ${startTime.toLocaleTimeString()}`);}
      localStorage.setItem('reportApiStartTime', startTime.getTime());

      const postRes = await postWithRetry(`${CONST_API_NODEJS_URL}/reports`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(ppptObj),
      }, 3, 2000);

      if (!postRes || !postRes.ok) {
        throw new Error('Failed to POST ppt payload');
      }

      try {
        const id2El = document.getElementById('id2');
        if (id2El) {
          const strongs = Array.from(id2El.querySelectorAll('strong'));
          strongs.forEach((s) => {
            const parent = s.parentNode;
            if (!parent) return;
            const frag = document.createDocumentFragment();
            while (s.firstChild) frag.appendChild(s.firstChild);
            parent.replaceChild(frag, s);
          });
        }
      } catch (removeErr) {
        console.warn('Failed to remove <strong> tags under id2:', removeErr);
      }

      setPptFileName({ fileName: fileName });

      const removingBase64 = (obj) => {
        const payload = obj.payload.map(d => ({ ...d, base64: null, pptData: null }))
        return { ...obj, payload: payload }
      }
      localStorage.setItem(localStorageKey, JSON.stringify(removingBase64(ppptObj)));
      setTimeout(() => { getPptStatusFunc() }, 1000)
      
      setPPTModalActive(false)
      setPptIdsType('')
      setPPTSubLhs([])
      setPPTSubLhsAppendices([])
      setPPTSubLhsProgression([])
      setPPTModalActiveAndClicked(false)
      setDownloading(false)

    } catch (error) {
      console.error('Export Error Handled:', error);
      localStorage.removeItem(localStorageKey);
      setPPTModalActive(false)
      setDownloading(false)
    }
  };

  const getPptStatusFunc = () => {
    const raw = pptFileName || JSON.parse(localStorage.getItem(localStorageKey));
    if (raw !== null) {
      checkIsDownloadingFunc()
      try {
          const fileName = raw.fileName;
          getPptStatus(fileName)
      } catch (err) {
        // Suppress parsing issues
      }
    }
  }

  useEffect(() => {
    if (pptSubLhs?.length > 0 && isDownloading) {
      setCheckStatus('start')
      setPptData(pptSubLhs)
    }
    if (pptSubLhsAppendices?.length > 0 && isDownloading) {
      setCheckStatus('start')
      setPptData(pptSubLhsAppendices)
    }
  }, [pptSubLhs, pptSubLhsAppendices, isDownloading])

  useEffect(() => {
    getPptStatusFunc()
    localStorage.removeItem('blobUrl');
  }, [])

  useEffect(() => {
    if (exportToPptObject && checkStatus === 'start' && pptData?.length > 0) {
      getData(exportToPptObject, pptData)
    }
  }, [exportToPptObject, checkStatus, pptData])

  return (
    <Box>
      {pptToolTipValues && <PptToolTip size={20} total={pptToolTipValues[1]} current={pptToolTipValues[0]} />}
    </Box>
  )
}

export default ExportToPptWithNode

const convertSingleImageToBase64 = async (d, elementId = null, type = 'jpeg', retries = 2, delayMs = 500) => {
  const id = elementId || `${d?.InsightsElementType}__${d?.InsightsElementId?.replaceAll('-', '')}`;
  let attempts = 0;
  const wait = (ms) => new Promise((res) => setTimeout(res, ms));
  
  while (attempts < retries) {
    try {
      const el = document.querySelector(`#${id}`);
      if (el) {
        el.classList.add("exportToPPT");
        if (type === 'jpeg') el.style.setProperty("background", "#FFFFFE", "important");
        
        const dataUrl = (type === 'png') ? await domtoimage.toPng(el) : await domtoimage.toJpeg(el, { quality: 0.95 });
        return dataUrl;
      }
    } catch (error) {
      console.warn(`Skipping image generation for ${id} (Attempt ${attempts + 1}):`, error);
    }
    attempts++;
    await wait(delayMs);
  }
  return null;
};

const convertMultiImageToBase64WithDims = async ({ d, selector, type = 'jpeg' }) => {
  try {
    const id = `${d.InsightsElementType}__${d.InsightsElementId.replaceAll('-', '')}`;
    const container = document.querySelector(`#${id}`) || document.querySelector(`#Appendices__${id}`) || document.querySelector(`#Progression__${id}`);

    if (!container) return [];

    if (type === 'jpeg') container.style.setProperty('background', '#FFFFFE', 'important');

    const nodes = container.querySelectorAll(selector);
    const outputs = [];
    let previousY = 0;

    for (const node of nodes) {
      try {
        if (node && node.childNodes.length > 0) {
          const rect = node.getBoundingClientRect();
          const width = rect.width;
          const height = rect.height;
          const oldBG = node.style.background;
          const imgAlt = node.getAttribute('title') || ''
        
          if (type === 'jpeg') node.style.background = '#FFFFFE';
          
          const dataUrl = (type === 'png') ? await domtoimage.toPng(node) : await domtoimage.toJpeg(node, { quality: 0.95 });

          outputs.push({
            image: dataUrl,
            w: width,
            h: height,
            x: 0,
            y: previousY,
            alt: imgAlt
          })

          previousY += height;
          node.style.background = oldBG;
        }
      } catch (nodeErr) {
        console.warn('Skipped a single multi-image node due to rendering error:', nodeErr);
      }
    }

    return outputs.filter(f => f?.image && f.image.length > 25);
  } catch (err) {
    console.warn('Skipped multi-image container due to error:', err);
    return [];
  }
};

const PptToolTip = ({
  size = 50,
  total = 100,
  current = 0,
  strokeWidth = 5,
}) => {
  const radius = (size - strokeWidth) / 2;  
  const circumference = 2 * Math.PI * radius;
  const [percentage, setPercentage] = useState(0);

  const {
    isFullScreen
  } = useGlobalStore()

  useEffect(() => {
    const percent = Math.min(current / total, 1);
    const newOffset = circumference * (1 - percent);
    const pVal = Math.round(percent*100)
    const finalVal = (pVal> 100 ? 100 : pVal)
    setPercentage(Math.max(percentage, finalVal))
  }, [current, total, circumference])

  return (
    <>
      {!isFullScreen && <ExportInfoToolTip>
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="15" viewBox="0 0 33 15" fill="none"><path d="M16.0215 0L32.043 15L1.52588e-05 15L16.0215 0Z" fill="black"/></svg>
        {percentage===100 ? 'Packaging report. Few seconds more...' : `Study is being exported ${percentage>0 ? `${percentage}%` : ''}`}
      </ExportInfoToolTip>}
    </>
  );
};

////////////////////////////////////////
let count = 0

const removeTags = (str) => {
  let data = str

  const replaceArray = [
    '<STRONG>',
    '</STRONG>',
    '<strong>',
    '</strong>',
    '<STRIKE>',
    '</STRIKE>',
    '<strike>',
    '</strike>',
    '<S>',
    '</S>',
    '<s>',
    '</s>',
    '<EM>',
    '</EM>',
    '<em>',
    '</em>',
    '<SUB>',
    '</SUB>',
    '<sub>',
    '</sub>',
    '<SUP>',
    '</SUP>',
    '<sup>',
    '</sup>',
    '<UNDERLINE>',
    '</UNDERLINE>',
    '<underline>',
    '</underline>',
  ]
  if (typeof data === 'string') {
    data = str.split('<ul>')[0]
    data = data.replaceAll('<sup>TM</sup>', ' ').replaceAll('<SUP>TM</SUP>', ' ')
    for (let r = 0; r < replaceArray.length; r++) {
      data = data.replaceAll(replaceArray[r], '')
    }
    data = data
      .replaceAll('<BR />', ' ')
      .replaceAll('<br />', ' ')
      .replaceAll('<BR>', ' ')
      .replaceAll('<br>', ' ')
    data = data
      .replaceAll('&nbsp;', ' ')
      .replaceAll('&amp;', '&')
      .replaceAll('&lt;', '<')
      .replaceAll('&gt;', '>')
      .replaceAll('&quot;', '\/')
      .replaceAll('&apos;', "'")
    data = data
      .replace(/<\/?span[^>]*>/g, '')
      .replace(/<\/?div[^>]*>/g, '')
      .replace(/<\/?p[^>]*>/g, '')
  }
  return data
}

export const nodeJsonFunc = async (nodes, parentNode) => {
  let obj = {}
  try {
    if (
      ['UL', 'OL', 'ULUL', 'OLOL', 'ULULUL', 'OLOLOL', 'ULULULUL', 'OLOLOLOL', 'ULULULULUL', 'OLOLOLOLOL', 'ULULULULULUL', 'OLOLOLOLOLOL'].includes(parentNode)
    ) {
      obj = []
    }
    for (let i = 0; i < nodes.length; i++) {
      const loopNode = nodes[i]
      let tag = loopNode.nodeName
      if (tag === 'DIV') {
        const txt = loopNode?.childNodes[0]?.nodeValue
        if (txt?.trim().length !== 0) {
          count++
          obj[tag + count] = {
            tag: tag,
            text: txt,
                content:
              loopNode?.childNodes?.length > 0
                ? [await nodeJsonFunc(loopNode.childNodes, tag)]
                : [],
          }
        }
      }
      if (tag === 'UL') {
        count++
        const tagNew =
          parentNode === 'LILILILILI'
            ? 'ULULULULULUL'
            : parentNode === 'LILILILI'
              ? 'ULULULULUL'
              : parentNode === 'LILILI'
                ? 'ULULULUL'
                : parentNode === 'LILI'
                  ? 'ULULUL'
                  : parentNode === 'LI'
                    ? 'ULUL'
                    : tag
        obj[tag + count] = {
          tag: tagNew,
          content:
            loopNode?.childNodes?.length > 0 ? await nodeJsonFunc(loopNode.childNodes, tagNew) : [],
        }
      }
      if (tag === 'LI') {
        const txt = removeTags(loopNode.innerHTML)
        if (txt?.trim().length !== 0) {
          const tagNew =
            (parentNode === 'ULULULULULUL' || parentNode === 'OLOLOLOLOLOL')
              ? 'LILILILILILI'
              : (parentNode === 'ULULULULUL' || parentNode === 'OLOLOLOLOL')
                ? 'LILILILILI'
                : (parentNode === 'ULULULUL' || parentNode === 'OLOLOLOL')
                  ? 'LILILILI'
                  : (parentNode === 'ULULUL' || parentNode === 'OLOLOL')
                    ? 'LILILI'
                    : (parentNode === 'ULUL' || parentNode === 'OLOL')
                      ? 'LILI'
                      : tag
          const txt2 = txt
          obj.push({
            tag: tagNew,
            text: txt,
            content:
                loopNode?.childNodes?.length > 1
                  ? await nodeJsonFunc(loopNode.childNodes, tagNew)
                  : '',
          })
        }
      }
      if (tag === 'P') {
        const txt = removeTags(loopNode.innerHTML) + '\n'
        if (txt?.trim().length !== 0) {
          count++
          obj[tag + count] = {
            tag: tag,
            text: txt,
            content: '',
          }
        }
      }
      if (tag === 'H4') {
        const txt = removeTags(loopNode.innerHTML) + '\n'
        if (txt?.trim().length !== 0) {
          count++
          obj[tag + count] = {
            tag: tag,
            text: txt,
            content: '',
          }
        }
      }
      if (tag === 'HR') {
        count++
        obj[tag + count] = {
          tag: tag,
          text: '',
          content: '',
        }
      }
    }
  } catch (error) {
    console.log('TCF 2 > Error --------- ', error)
  }
  return obj
}

